import { GeometryUtils } from "./Geometry.js";
export { VectorState };
class VectorState {
    constructor({ cross, dot }) {
        this.cross = cross;
        this.dot = dot;
    }
    static of(a, b) {
        return new VectorState(GeometryUtils.vectorState(a, b));
    }
    isSameDirection() {
        return this.cross === 0 && this.dot > 0;
    }
    isOppositeDirection() {
        return this.cross === 0 && this.dot < 0;
    }
    isLeftOrthogonal() {
        return this.cross > 0 && this.dot === 0;
    }
    isRightOrthogonal() {
        return this.cross < 0 && this.dot === 0;
    }
    isCollinear() {
        return this.cross === 0;
    }
    isLeft() {
        return this.cross > 0;
    }
    isRight() {
        return this.cross < 0;
    }
    isOrthogonal() {
        return this.dot === 0;
    }
    isAcute() {
        return this.dot > 0;
    }
    isObtuse() {
        return this.dot < 0;
    }
}
//# sourceMappingURL=VectorState.js.map